// store/slices/dashboard.ts — the live aggregate counters.
//
// Overwritten wholesale on every `dashboard_refresh` event. The admin profile
// from sync:initial.admin lives here too, so the topbar can read it without
// asking the auth slice.

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboard } from "../types";

interface AdminProfile {
  id: string;
  email: string;
  name: string | null;
}

interface DashboardState {
  value: AdminDashboard | null;
  admin: AdminProfile | null;
  /** Server version from sync:initial. "—" until the first sync lands; an
   *  older server that omits the field also leaves this at "—". */
  serverVersion: string;
}

const initialState: DashboardState = {
  value: null,
  admin: null,
  serverVersion: "—",
};

const dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    set(state, action: PayloadAction<AdminDashboard>) {
      state.value = action.payload;
    },
    setAdmin(state, action: PayloadAction<AdminProfile>) {
      state.admin = action.payload;
    },
    setServerVersion(state, action: PayloadAction<string>) {
      state.serverVersion = action.payload;
    },
    clear(state) {
      state.value = null;
      state.admin = null;
      state.serverVersion = "—";
    },
  },
});

export default dashboard;
